/**************************************************
 * Nombre:       Detalle_Relacionados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloHuella from "./SubComponentes/TituloHuella";
import {useSeleccion} from "./SubComponentes/Hooks/useSeleccion";
import Lista_Productos from "./Lista_Productos";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Detalle_Relacionados = ({item}) => {
   const [productos, setProductos] = useState([])

    useEffect(() => {

        if (item.tipo && item.categoria){
            let tipo = item.tipo
            let categoria = item.categoria

            let w = [where('tipo', '==', tipo), where('categoria', '==', categoria)]
            obtenerColWheres({col: 'productos', wheres:w}).then((dox) =>{
                if (dox.res){
                    setProductos(dox.data)
                }
            })
        }

    },[item])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <TituloHuella titulo={'Productos Relacionados'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                            <Lista_Productos items={productos}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Relacionados